import React from 'react';
import './styles.css';

const MobileMe = ({ isDarkMode }) => {
    return (
        <div className="mobile-page">
            <div className="mobile-content-wrapper">
                {/* Hero Section with Image */}
                <div className="mobile-hero-section">
                    <img
                        src="/images/siteElements/topImg.jpeg"
                        alt="Profile"
                        className="mobile-hero-image"
                    />
                    <div className="mobile-hero-overlay">
                        <h1 className="mobile-page-title">About Me</h1>
                    </div>
                </div>

                {/* Content Section */}
                <div className="mobile-content-section">
                    {/* About Text */}
                    <div className="mobile-text-card">
                        <p className="mobile-about-text">
                            Hello, I'm Aviral, a dual degree CS student at IIIT Hyderabad. I'm pursuing
                            my UG thesis under Prof. Karthik Vaidhyanathan at SERC, where I try to look
                            serious enough to pass as a researcher.
                        </p>
                        <p className="mobile-about-text">
                            Somewhere between npm install, uv run and existential crisis, I got decent at
                            building things that sometimes sneak their way to deployment and trick users
                            into good experience.
                        </p>
                        <p className="mobile-about-text">
                            When copilot is not available (most likely due to yet another cloudflare outage),
                            you'll find me watching Formula 1, binging documentaries or playing video games.
                            I also enjoy trying new things: places, food, hobbies, life decisions I'll regret
                            in a week.
                        </p>
                    </div>

                    {/* Contact Info Card */}
                    <div className="mobile-info-card">
                        <div className="mobile-info-item">
                            <span className="mobile-info-label">Mail</span>
                            <span className="mobile-info-value">avilol9440@gmail.com</span>
                        </div>
                        <div className="mobile-info-item">
                            <span className="mobile-info-label">Contact</span>
                            <span className="mobile-info-value">+91 XXXXX-X1731</span>
                        </div>
                        <div className="mobile-info-item">
                            <span className="mobile-info-label">Residence</span>
                            <span className="mobile-info-value">New Delhi, India</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileMe;
